import { render, staticRenderFns } from "./UserGeneralConfiguration.vue?vue&type=template&id=49e6c840&scoped=true&"
import script from "./UserGeneralConfiguration.vue?vue&type=script&lang=js&"
export * from "./UserGeneralConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./UserGeneralConfiguration.vue?vue&type=style&index=0&id=49e6c840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e6c840",
  null
  
)

export default component.exports